import BaseController from "@controllers/base-controller";
import "@utils/controller-loader";

// function app() {
//   // BaseController.register();

//   console.log("[App.js] loaded");
// }

// app();
